import Lottie from "lottie-react";
import { useEffect, useState } from "react";

export const AnimatedAIAssistantIcon = () => {
  const [animationData, setAnimationData] = useState<object | null>(null);

  useEffect(() => {
    fetch("/lottie/ai-chatbot-logogram.json")
      .then((r) => r.json())
      .then(setAnimationData);
  }, []);

  if (!animationData) return <div className="size-20 lg:size-36" />;
  return (
    <div className="size-20 lg:size-24">
      <Lottie
        loop
        autoplay
        className="w-full h-full"
        animationData={animationData}
      />
    </div>
  );
};
